import { writable } from 'svelte/store';
export const idPageHome = "home";
export const idPageLogin = "login";
export const idPageEntreprises = "nosentreprises";
export const idPageEntreprise = "entreprise";
export const idPageMembres = "nosmembres";
export const idPageRegistration = "registration";
export const idPageResetPassword = "resetpassword";
export const idPageModifPassword = "modifpassword";
export const idPageUserAccount = "useraccount";
export const idPageNosEvenements = "nosevenements";
export const idPageNosVideos = "nosvideos";
export const idPageNosChantiers = "noschantiers";
export const idPageChantier = "chantier";
export const idPageNosLivrables = "noslivrables";
export const idPageRealisations = "realisations";
export const idPagePressRevue = "pressrevue";
export const idPagePlenaries = "plenaries";
export const idPageEcosystem = "ecosystem";
export const idPageDevenirPartenaire = "devenirpartenaire";
export const idPageDevenirMembre = "devenirmembre";
export const idPagePartenaire = "partenaire";
export const idPageBlog = "blog";
export const idPageArticle = "article";
export const idPageMyArticles = "myarticles";
export const idPageArticleEdition = "articleedition";
export const idPagePress = "press";
export const idPageNosPartenaires = "nospartenaires";
export const idPageNosPartenairesFormations = "nospartenairesformations";
export const namePageHome = "Accueil";
export const namePageLogin = "Connexion";
export const namePageEntreprises = "Nos entreprises";
export const namePageEntreprise = "Entreprise";
export const namePageMembres = "Nos membres";
export const namePageRegistration = "Inscription";
export const namePageResetPassword = "Réinitialisation du mot de passe";
export const namePageModifPassword = "Modification du mot de passe";
export const namePageUserAccount = "Compte utilisateur";
export const namePageNosEvenements = "Nos évènements";
export const namePageNosVideos = "Nos vidéos";
export const namePageNosChantiers = "Nos chantiers";
export const namePageChantier = "Chantiers";
export const namePageNosLivrables = "Nos livrables";
export const namePageRealisations = "Nos réalisations";
export const namePagePressRevue = "Revue de presse";
export const namePagePlenaries = "Plénières";
export const namePageEcosystem = "Écosystème APIs";
export const namePageDevenirPartenaire = "Devenir partenaire";
export const namePageDevenirMembre = "Devenir membre";
export const namePagePartenaire = "Partenaire";
export const namePageBlog = "Blog";
export const namePageArticle = "Article";
export const namePageMyArticles = "Mes articles";
export const namePageArticleEdition = "Édition d'un Article";
export const namePagePress = "Presse";
export const namePageNosPartenaires = "Nos partenaires";
export const namePageNosPartenairesFormations = "Formations de nos partenaires";
export const storeFirstDisplayHome = writable(true);
